export default __webpack_public_path__ + "static/media/thumbnail-14.d46b428a.jpg";